import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Parser from 'html-react-parser';
import 'tippy.js/dist/tippy.css';

function WelcomeHeader() {
  
  const [welcomeText, setWelcomeText] = useState('');
  const [welcomeImageClass, setWelcomeImageClass] = useState('');
  const [titleClass, setTitleClass] = useState('left-bottom-title');
  const location = useLocation();
  const cleanedPath = location.pathname.endsWith('/')
    ? location.pathname.slice(0, -1).toLowerCase()
    : location.pathname.toLowerCase();

  useEffect(() => {
    const updateWelcomeText = async () => {
      let newWelcomeText = '';
      let newWelcomeImageClass = "";
      let newTitleClass = "left-bottom-title";
      
      switch (cleanedPath) {
        case '': // Home
        case '/home': // Home
          newWelcomeText = 'Irish Funds\' Survey Portal<br/>';
          newTitleClass = "";
          break;
        case '/drivers-of-innovation':
          newWelcomeText = 'Innovation Survey<br/>';
          newWelcomeImageClass = "welcome-header-policy";
          break;
        default:
          newWelcomeText = cleanedPath.replace("/", "");
      }
      setWelcomeImageClass(newWelcomeImageClass);
      setWelcomeText(newWelcomeText);
      setTitleClass(newTitleClass);
    };
    updateWelcomeText();
  }, [cleanedPath]);


  return (
    <>
      <section className={`welcome-header ${welcomeImageClass} hide-on-mobile`}>
        <div className='container'>

          <>
            <div className='titlewrapper welcome-title hide-on-mobile'>
              <h1 className={`welcometext ${titleClass}`}>
                {Parser(welcomeText)}
              </h1>
              <svg role="presentation" viewBox="0 0 28 95" preserveAspectRatio="none">
                <path d="M28 47.5L-2.08616e-07 95L-2.08616e-07 0L28 47.5Z" fill=""></path>
              </svg>
            </div>
            
          </>

        </div>
      </section>

      <section className={`welcome-header-mobile ${welcomeImageClass} show-on-mobile`}>
        <div className='container'>
          <>
            <div className='show-on-mobile'>
              <h1 className='welcome-title-mobile'>
                {Parser(welcomeText)}
              </h1>
            </div>
            <div className='titlewrapper welcome-title hide-on-mobile'>
              <h1 className={`welcometext ${titleClass}`}>
                {Parser(welcomeText)}
              </h1>
            </div>
          </>
        </div>
      </section>

    </>
  );
}

export default WelcomeHeader;
